/**
 * Card Grid section
 */

// Work in progress!
// Apply focus to the button when a card is a link and is hovered over or focused
// $('.s-card-grid__card-wrap-link').bind('hover focus', function() {
//   $('.s-card-grid__card-button').focus();
// });



// WEBPACK FOOTER //
// ./scripts/routes/sections/card-grid.js